<h2 class="text_large font-bold text-ink-dark mb-4">{{label}}</h2>
